import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getUnmaskingInvitation({ payload: { signal, id } }) {
  try {
    const { data } = yield call(fetch, { api: api.unmasking.invitations.get, id, signal });

    yield put(actions.getUnmaskingInvitationDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getUnmaskingInvitationFailed,
      endpoint: api.unmasking.invitations.get.url
    });
  }
}

export const getUnmaskingInvitationSaga = takeEvery(types.GET_UNMASKING_INVITATION_REQUEST, getUnmaskingInvitation);